export default {
  authServiceUrl: 'https://id.1ketoan.com',
  authApiUrl: 'https://id.1ketoan.com/api',
  accApiUrl: 'https://api.1ketoan.com',
};



// WEBPACK FOOTER //
// ./src/configs/prod.js